import {Button, Card, Col, FormControl, FormGroup, Row} from 'react-bootstrap';

const StockItSearch = (props) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Card className="admin-search-filter">
      <Card.Body>
        <Row>
          <Col md={3}>
            <FormGroup>
              Name
              <FormControl
                onChange={props.onNameChange}
                onKeyPress={doSearch}
                placeholder="Name"
                value={props.nameValue}
              />
            </FormGroup>
          </Col>
          <Col md={6} className="actions" style={{marginTop: '20px'}}>
            <Button
              className="red-ghost-btn"
              onClick={props.onClear}
            >Clear search/filters
            </Button>
            <Button
              className="red-ghost-btn"
              onClick={props.onSearch}
            >Search
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default StockItSearch;
